"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IEquipmentType = void 0;
var IEquipmentType;
(function (IEquipmentType) {
    IEquipmentType["App"] = "App";
    IEquipmentType["Bike"] = "Bike";
    IEquipmentType["Elliptical"] = "Elliptical";
    IEquipmentType["Equipmentless"] = "Equipmentless";
    IEquipmentType["FreeStrider"] = "FreeStrider";
    IEquipmentType["Fusion"] = "Fusion";
    IEquipmentType["InclineTrainer"] = "Incline Trainer";
    IEquipmentType["Mirror"] = "Mirror";
    IEquipmentType["None"] = "None";
    IEquipmentType["Rower"] = "Rower";
    IEquipmentType["Shoes"] = "Shoes";
    IEquipmentType["SpinBike"] = "SpinBike";
    IEquipmentType["StationaryBike"] = "Stationary Bike";
    IEquipmentType["Stepper"] = "Stepper";
    IEquipmentType["Strength"] = "Strength";
    IEquipmentType["Strider"] = "Strider";
    IEquipmentType["StudioBike"] = "Studio Bike";
    IEquipmentType["TDFBike"] = "TDF Bike";
    IEquipmentType["Treadmill"] = "Treadmill";
    IEquipmentType["Vault"] = "Vault";
    IEquipmentType["VerticalElliptical"] = "VerticalElliptical";
    IEquipmentType["VibrationPlatform"] = "Vibration Platform";
    IEquipmentType["Wearable"] = "wearable";
})(IEquipmentType || (exports.IEquipmentType = IEquipmentType = {}));
//# sourceMappingURL=equipment-type.js.map